import React from "react";
import ConnectionInfo from "../../components/Contact/ConnectionInfo";
import ContactMap from "../../components/Contact/ContactMap";
import PageHeader from "../../components/common/PageHeader";

const Contact = () => {
  return (
    <div>
      <PageHeader pageName={"Contact Us"} />

      <ConnectionInfo />
      <ContactMap />
    </div>
  );
};

export default Contact;
